// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__URzKY","type":"styles_type__3SAbM","choices":"styles_choices__1e8rw"};